import { NextPage } from 'next';

import { PublicFormCard, PageLayout } from '../components';

const Register: NextPage = () => {
  return (
    <PageLayout title="Sign up now">
      <section className="flex flex-col min-h-screen bg-gradient-wave bg-gradient-wave--whole pt-40">
        <div className="c-container">
          <PublicFormCard
            description="Create an account with KANZI"
            image={<img alt="Register for Kanzi" className="md:max-w-24" loading="lazy" src="/images/kanzi-logo-full-dark.svg" />}
            title="Register"
          />
        </div>
      </section>
    </PageLayout>
  );
};

// eslint-disable-next-line import/no-default-export
export default Register;
